"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTextAudioParts = void 0;
var formatTextAudioParts = function (data) {
    var input = __assign({}, data);
    var textAudioPartRegex = /text(?:_(\d+))?([a-zA-Z]+)(?:_(\d+))?/;
    var keys = Object.keys(input).filter(function (key) { return textAudioPartRegex.test(key); });
    keys.forEach(function (key) {
        var matches = key.match(textAudioPartRegex);
        if (!matches) {
            return;
        }
        var textIndex = +matches[1];
        var propertyKey = matches[2].toLowerCase();
        if (propertyKey === 'completeaudio') {
            if (textIndex) {
                input["textAudio_".concat(textIndex)] = input[key];
            }
            else {
                input["textAudio"] = input[key];
            }
            delete input[key];
            return;
        }
        var propertyIndex = +matches[3] - 1;
        if (propertyKey === 'audio' &&
            !textIndex &&
            data["textText_".concat(propertyIndex + 1)] === undefined) {
            return;
        }
        var textAudioPartsKey = "textAudioParts".concat((textIndex && '_' + textIndex) || '');
        if (!input[textAudioPartsKey]) {
            input[textAudioPartsKey] = [];
        }
        var audioParts = input[textAudioPartsKey];
        if (!audioParts[propertyIndex]) {
            audioParts[propertyIndex] = {};
        }
        audioParts[propertyIndex][propertyKey] = input[key];
        delete input[key];
    });
    return input;
};
exports.formatTextAudioParts = formatTextAudioParts;
